// LOAD STYLESHEETS
import '../scss/main.scss';

// LOAD LIBS/JS
import {balanceElements, onWindowEvents} from './utils';
import '../lib/bootstrap-5.3.2/js/src/modal';
import '../lib/bootstrap-5.3.2/js/src/collapse';
import '../lib/bootstrap-5.3.2/js/src/tab';
// import '../lib/bootstrap-5.3.2/js/src/tooltip';
// import '../lib/swiper/swiper-bundle.js';

require.context('app/components', true, /\.scss$/i).keys().map(name => {
  name = name.slice(2, -5);
  import(`app/components/${name}.scss`);
});

// LOAD TEMPLATES SCSS
require.context('template-parts/', true, /\.scss$/i).keys().map(name => {
  name = name.slice(2, -5);
  import(`template-parts/${name}.scss`);
});

// MAIN SCRIPT
jQuery(document).ready(function($) {
  const App = window['App'] || {};

  $('li.mega-menu-item').on('open_panel', function() {
      alert( 'ddd' );
  });

  App.init = function() {
    // Balance all elements
    onWindowEvents(() => {
      App.balanceAllElements();
    }, 1, 1, 1, 0);

    // Balance elements after Ajax Load More
    window.almComplete = function(alm) {
      App.balanceAllElements();
    };

    // Wow animations
    if ('WOW' in window) {
      const wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animate__animated',
        offset: 0,
        mobile: true,
        live: true
      });

      wow.init();
    }
    //App.initSliders();
    
    App.initSeachDropdown();
    App.initMenuDropdown();
    App.initMobileMenu();
    App.initResourcesFilter();
    App.initTableOfContents();
    App.initPartnersGridItem();
    App.initContactModal();

    // Init tooltips
    // $('[data-bs-toggle="tooltip"]').tooltip();
    $( '[role="tablist"]' ).tab();
    
    MktoForms2.whenReady(function (form) { form.addHiddenFields({ webpage : document.location.href }); });
  };

  App.balanceAllElements = function() {
    balanceElements($('.balance-elements'), false, 30);
  };

  App.initSeachDropdown = function() {
    var searchToggle = $( '.header .search-toggle' );
    var searchInput = $( '.header input[name=s]' );
    var searchInputMobile = $( '.search-box input[name=s]' );

    var template = wp.template( 'search-group-item' );

    var do_search = function( search_keyword = '' ) {
      $.ajax( {
        url: App.ajaxUrl,
        method: 'GET',
        data: {
          action: 'global_search',
          ajax_nonce: App.ajaxNonce,
          search_keyword: search_keyword
        },
        success: function(res){
          $( '.search-results-groups' ).html( '' );
          res.forEach(group => {
            $( '.search-results-groups' ).append( template( group ) );
          });
          console.log( res );
        }
      } );
    }

    searchToggle.on( 'click', function( e ){
      e.preventDefault();
      $( 'body' ).toggleClass( 'header-search-active' );
      searchInput.focus();
      do_search( searchInput.val() );
    } );
      
      searchInput.on( 'keyup', function(){
        do_search( $(this).val() );
      } );

      searchInputMobile.on( 'keyup', function(){
        do_search( $(this).val() );
      } );

    $(document).mouseup(function (e) {
        if ($(e.target).
            closest(".container").
            length=== 0) {
            $( 'body' ).removeClass( 'header-search-active' );
        }
    });
  }

  App.initMenuDropdown = function() {
    $( '.comp-megamenu-dropdown-item .menu-items li a' ).hover( function(){
      const i = $( this ).closest('li').index();
      $( this ).closest('.comp-megamenu-dropdown-item').find( '.comp-megamenu-dropdown-item__center .menu-content' ).hide();
      $( this ).closest('.comp-megamenu-dropdown-item').find( '.comp-megamenu-dropdown-item__center .menu-content' ).eq(i).show();

      $( this ).closest('.comp-megamenu-dropdown-item').find( '.comp-megamenu-dropdown-item__right .side-content' ).hide();
      $( this ).closest('.comp-megamenu-dropdown-item').find( '.comp-megamenu-dropdown-item__right .side-content' ).eq(i).show();
    } );
    $( '.show-dropdown' ).click(function( e ) {
      $( this ).parent().toggleClass( 'active' );
      $( this ).parent().find( 'ul.dropdown' ).toggle();
    } );
  }

  App.initMobileMenu = function() {
    $("#menu-mobile-navigation").simpleMobileMenu({
      onMenuLoad: function(menu) {
      },
      onMenuToggle: function(menu, opened) {
          
      },
      "menuStyle": "slide"
  });
  }

  App.initResourcesFilter = function() {

    const post_name = $( '.comp-posts-grid' ).attr( 'data-post-name' );

    window.almComplete = function( alm ){
      var percent = (alm.postcount / alm.totalposts) * 100;
      var template_end = wp.template( 'team-member-end-card' );
      if( $( '.alm-btn-wrap .total-posts' ).length == 0 ) {
        $( '.alm-btn-wrap' ).prepend( '<div class="total-posts">You\'ve viewed ' + alm.postcount + ' of ' + alm.totalposts + ' ' + post_name + '<div class="percent" style="width:'+ percent +'%"></div></div>' );
      } else {
        $( '.alm-btn-wrap .total-posts' ).html( 'You\'ve viewed ' + alm.postcount + ' of ' + alm.totalposts + ' resources<div class="percent" style="width:'+ percent +'%"></div>' );
      }
      if( post_name == 'Team Members' && alm.postcount == alm.totalposts ){
        $( '.comp-posts-grid' ).find( '.alm-reveal' ).append( template_end( [] ) );
      }
      if( alm.postcount == alm.totalposts ){
        $( '.alm-btn-wrap .total-posts' ).hide();
      }
    }

    window.almFilterComplete = function(){
      $( '.comp-featured-resources' ).hide();
    }
    $( '.alm-filter--taxonomy.has-all' ).each( function(){
      $( this ).find( 'ul' ).prepend( '<li class="alm-filter--radio"><div class="alm-filter--link field-radio field-all " id="radio-all-99" data-type="radio" data-value="all" role="radio" tabindex="0" aria-checked="true">All</div></li>' );
    } ); 
  }

  App.initTableOfContents = function() {

    var tableOfContents = $('.comp-table-of-contents ul');

    if( $('.comp-table-of-contents ul').length == 0 ) {
      return false;
    }
    
    if( $('.main-content *:is(h2)').length == 0 ) {
      $('.comp-table-of-contents').parent().hide();
      return false;
    }

    // Find all header elements in the content
    $('.main-content *:is(h2)').each(function(index, element) {

      // Create list item and anchor for each header
      var id = "heading" + parseInt(index + 1);
      $( this ).attr( 'id', id );
      var listItem = $('<li></li>');
      var anchor = $('<a></a>').text($(element).text()).attr('href', '#' + id);
      listItem.append(anchor);
      tableOfContents.append(listItem);

      anchor.on( 'click', function( e ){
        e.preventDefault();
        var target  = $( this ).attr( 'href' );
        $('html').animate(
          {
            scrollTop: $(target).offset().top - 100,
          },
          800 //speed
        );
      } );

    });

  }

  App.initPartnersGridItem = function(){

    $( document ).on( 'click', '.elm-post-partner .readmore', function( e ){
      alert( 'ddd' );
      e.preventDefault();
      // $( this ).closest( '.elm-post-partner' ).find( '.entry-meta' ).slideToggle();
    } );
  }

  App.initBlockContactForms = function(){
    if( $( '.block-contact-forms' ).length > 0 ) {

      //tabs
      $( '.block-contact-forms__tabs a' ).on( 'click', function(e){
        e.preventDefault();
        $( '.block-contact-forms__tabs a' ).removeClass( 'active' );
        $( this ).addClass( 'active' );
      } )
    }
  }

  App.initContactModal = function() {
    $( '*[href="#contact-modal"]' ).on( 'click', function(){
      $('#comp-contact-modal').modal('show');
    } );
  }

  // No code should be added below this line
  window['App'] = App;
  App.init();
});